<template>
    <div class="h6">{{ $t('views.onboarding.title') }}: {{$t('common.step_1')}} 1/4</div>
    <h1 class="h2">{{ $t('views.onboarding.titles.1') }}</h1>
    <LanguageSwitch />
    <p class="p">{{ $t('views.onboarding.descriptions.1') }}</p>
    <ol class="list-ordered">
        <li>
            <div class="icon-filter-pos"></div>
            <div class="content">
                <p class="title">{{ $t('views.onboarding.items.search.title') }}</p>
                <p class="description">{{ $t('views.onboarding.items.search.description') }}</p>
            </div>
        </li>
        <li>
            <div class="icon-new-pos"></div>
            <div class="content">
                <p class="title">{{ $t('views.onboarding.items.suspects.title') }}</p>
                <p class="description">{{ $t('views.onboarding.items.suspects.description') }}</p>
            </div>
        </li>
        <li>
            <div class="icon-target-pos"></div>
            <div class="content">
                <p class="title">{{ $t('views.onboarding.items.qualify.title') }}</p>
                <p class="description">{{ $t('views.onboarding.items.qualify.description') }}</p>
            </div>
        </li>
        <li>
            <div class="icon-save-pos"></div>
            <div class="content">
                <p class="title">{{ $t('views.onboarding.items.prospects.title') }}</p>
                <p class="description">{{ $t('views.onboarding.items.prospects.description') }}</p>
            </div>
        </li>
    </ol>
</template>

<script>
    import LanguageSwitch from '@/components/elements/misc/LanguageSwitch';
    export default {
            name: 'OnboardingStep1',
            components: {
                LanguageSwitch
            },
    }
</script>
